<template>
    <div>
        <b-button variant="primary" @click.stop="abrirModal()"
            >Inserir Apoios</b-button
        >
        <b-modal v-model="mostrarModal" @show="preencherModal()" size="lg">
            <div slot="modal-title">
                Equipe de Apoio - Colaboradores Disponíveis
            </div>
            <b-row>
                <b-col sm="12">
                    <app-tabela
                        idTabela="tblApoiosDisponiveis"
                        :itens="apoiosDisponiveis"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                    >
                        <template slot="selecao" slot-scope="data">
                            <b-form-checkbox
                                :value="data"
                                v-model="apoiosSelecionados"
                            ></b-form-checkbox>
                        </template>
                    </app-tabela>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="apoiosSelecionados.length == 0"
                    @click.stop="confirmarSalvar()"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        apoiosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            apoiosSelecionados: [],
            apoiosDisponiveis: [],
            campos: [
                {
                    key: 'selecao',
                    label: ''
                },
                {
                    key: 'matricula',
                    label: 'Matrícula',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'colaborador',
                    label: 'Colaborador',
                    sortable: true,
                    filterable: true
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        fecharModal() {
            this.apoiosDisponiveis = []
            this.apoiosSelecionados = []
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
        },

        preencherModal() {
            this.obterApoiosDisponiveis()
        },

        obterApoiosDisponiveis() {
            this.$store.dispatch('addRequest')
            this.apoiosServicos.obterDisponiveis().then(response => {
                if (response) {
                    if (response.success) {
                        this.apoiosDisponiveis = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter colaboradores disponíveis',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Inserção de apoios',
                html: `Confirma a inserção dos colaboradores selecionados na equipe de apoio?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            let apoiosDto = {
                colaboradores: this.apoiosSelecionados
            }
            this.$store.dispatch('addRequest')
            this.apoiosServicos.inserirApoios(apoiosDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Colaboradores inseridos com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterApoiosAtualizados')
                        this.fecharModal()
                    } else {
                        this.$toast.error(
                            'Erro ao salvar os colaboradores selecionados',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {}
}
</script>
